import * as React from "react";
import { useEffect } from "react";
import "../../proposols/step1/proposol.css";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { set_info1 } from "../../../Redux/action";
import { CustomerDetails } from "../../../Redux/actions/NumBikeation";
import { CalendarOutlined, CheckOutlined } from "@ant-design/icons";
import {
  Col,
  Form,
  Input,
  Row,
  Select,
  Button,
  Radio,
  DatePicker,
} from "antd/lib";
import moment from "moment";
import axiosInstance from "../../../Redux/axios/AxiosInstance";
// import Ownerdisplay from "./Ownerdisplay";
import CustomerdisplayNew from "./NewCustDisplay";

function KycVerifyNewVeh({ showStep1, setShowStep1, Ref }) {
  // console.log('step2.... ',showStep1)
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [formLayout] = useState("vertical");
  const CustDetail = useSelector((state) => state?.common?.customerDetail);
  const vehicleDetail = useSelector((state) => state?.common?.vahanData);
  const OwnerInfo = useSelector((state) => state?.addressdetail?.info1);
  const SelectedQQ = useSelector((state) => state?.common?.selectedQuote);
  const Bikenum = useSelector((state) => state?.vehicledetail?.bikenum);
  const QuickQuotePost = useSelector(
    (state) => state?.vehicledetail?.quickQuotePost
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [BaseUrl, setBaseURL] = useState(process.env.REACT_APP_UAT_BASE_URL);
  const [Age, setAge] = useState("");
  const [dob, setDob] = useState("");
  const [showCkyc, setShowCyc] = useState(false);
  const [showAadhaar, setShowAadhar] = useState(false);
  const [kycNumvalue, setkycNum] = useState("No");
  const [iciciKycSuccess, setIciciKycSuccess] = useState("");
  const [iciciKycError, setIciciKycError] = useState("");
  const [value, setValue] = useState("");
  const [ckycDocId, setckycDocId] = useState(
    CustDetail?.ckycReferenceDocId ? CustDetail?.ckycReferenceDocId : "D07"
  );
  const [CkycType, setCkycType] = useState(
    CustDetail?.ckyc_type ? CustDetail?.ckyc_type : "PAN"
  );
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };
  //   useEffect(() => {
  //     // FetchPin()
  //     const url = `${BaseUrl}states`;
  //     const config = {
  //       headers: {
  //         Authorization: "Bearer " + reg.token,
  //       },
  //     };
  //     axios
  //       .get(url, config)
  //       .then((res) => {
  //         // console.log(res);
  //         const resp = res.data.data;
  //         // console.log(resp);
  //         const statesArray = Object.keys(resp).map((id) => ({
  //           id,
  //           label: resp[id],
  //         }));
  //         setOptions(statesArray);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }, [BaseUrl]);
  useEffect(() => {
    if (CkycType === "AADHAAR") {
      setShowAadhar(true);
    }
  }, [CkycType]);

  const onChange = (e) => {
    // console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ PAN_Number: e.target.value });
  };
  const handleAadhaarNumberChange = (e) => {
    const inputValue = e.target.value.replace(/\s/g, "").replace(/\D/g, "");
    const truncatedValue = inputValue.slice(0, 12);
    const formattedValue = truncatedValue.replace(/^[01]/, "");
    const finalValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1 ");
    e.target.value = finalValue;
    form.setFieldsValue({ aadhaar_number: finalValue });
  };
  const handleGSTChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ gst_number: e.target.value });
  };
  const calculateAge = (date) => {
    // console.log(date);

    const dateString = moment(date).format("YYYY-MM-DD");
    // console.log(dateString);

    setDob(dateString);
    const dobObject = new Date(date); // Convert the date string to a Date object
    // console.log(dobObject);
    const ageDifMs = Date.now() - dobObject.getTime(); // Get the difference in milliseconds
    // console.log(ageDifMs);

    const ageDate = new Date(ageDifMs); // Create a new date object using the difference
    // console.log(ageDate);

    const ageInYears = Math.abs(ageDate.getUTCFullYear() - 1970).toString();
    // console.log(ageInYears);
    if (ageInYears === "53") {
      setAge("");
    } else {
      setAge(ageInYears);
    }
    // console.log(Age);
  };
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };
  // console.log(ckycDocId);
  const onFinish = (data) => {
    // console.log("data", data);
    const formatedDate = moment(data?.DateOfBirth)
      .format("DD-MMM-YYYY")
      .toUpperCase();
    console.log("formatedDate", formatedDate);
    data.DateOfBirth = formatedDate;
    data.ckyc_type = CkycType;
    data.ckycReferenceDocId = ckycDocId;
    switch (ckycDocId) {
      case "D03":
        data.ckycReferenceNumber = data?.aadhaar_number;
        break;
      case "D07":
        data.ckycReferenceNumber = data?.PAN_Number;
        break;
      case "D02":
        data.ckycReferenceNumber = data?.ckyc_number;
        break;
      default:
    }
    setLoading(true);
    // console.log(data);
    dispatch(CustomerDetails(data));
    if (SelectedQQ?.provider !== "icici") {
      const timeoutId = setTimeout(() => {
        setLoading(false);
        setShowStep1(true);
        Ref.current?.scrollIntoView({ behavior: "smooth" });
      }, 500);
      return () => clearTimeout(timeoutId);
    }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };
  const handleReview = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      history.push("/login");
    }, 1000);
  };
  const onChangeCkycType = (e) => {
    //console.log(e);
    setCkycType(e);
    if (e === "AADHAAR") {
      setShowAadhar(true);
      setckycDocId("D03");
    } else if (e === "PAN") {
      setShowAadhar(false);
      setckycDocId("D07");
    }
  };
  const OnckycChange = (e) => {
    setkycNum(e.target.value);
    // console.log("radio checked", e.target.value);
    if (e.target.value === "Yes") {
      setShowCyc(true);
      setShowAadhar(false);
      setckycDocId("D02");
      setCkycType("CKYC");
    } else if (e.target.value === "No") {
      setShowCyc(false);
      setShowAadhar(true);
      switch (CkycType) {
        case "AADHAAR NUMBER":
          setckycDocId("D03");
          break;
        case "PAN NUMBER":
          setckycDocId("D07");
          break;
        default:
          setckycDocId("");
          break;
      }
    }
  };
  const handleKYCiCICI = (values) => {
    console.log("handleKYCiCICI", values);
    console.log("CkycType", CkycType);
    setLoading(true);
    setShowStep1(false);
    let aadhaarNumber = values?.aadhaar_number;
    aadhaarNumber = aadhaarNumber?.replace(/\s/g, "");
    //console.log(aadhaarNumber);

    let post = {
      insurance_id: Bikenum?.bike_insurance_id,
      pan_card_number: values?.PAN_Number,
      dob: moment(values?.DateOfBirth).format("DD-MM-YYYY"),
      type: CkycType,
      //
      aadhaar_number: aadhaarNumber,
      full_name: values?.AadhaarName,
      gender: values?.gender === "male" ? "M" : "F",
    };
    axiosInstance
      .post(
        `v1/bike_insurance/insurers/${SelectedQQ?.provider}/kyc_status`,
        post
      )
      .then((res) => {
        // console.log(res)
        if (res?.data?.statusMessage === "Success") {
          let KYC = res?.data?.kyc_details;
          var data = {
            Owner: KYC?.first_name,
            Mobile: KYC?.mobile_number,
            Email: KYC?.email,
            Address: KYC?.permanent_address?.address_line_1,
            CkycNumber: KYC?.ckyc_number,
            City: KYC?.permanent_address?.city,
            il_kyc_ref_no: KYC?.il_kyc_ref_no,
            Pincode: KYC?.permanent_address?.pin_code,
          };
          dispatch(set_info1(data));
          setLoading(false);
          setIciciKycError("");
          setIciciKycSuccess("KYC Verified Successfully");
          setTimeout(() => {
            setShowStep1(true);
            Ref.current?.scrollIntoView({ behavior: "smooth" });
          }, 1000);
        } else {
          setLoading(false);
          setShowStep1(false);
          setIciciKycError(res?.data?.message);
          setIciciKycSuccess("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // console.log(options)
  return (
    <>
      {showStep1 ? (
        <CustomerdisplayNew />
      ) : (
        <div className="gridparent-skb">
          <div className=" d-flex bg-white customer-card">
            <Form
              form={form}
              style={{ width: "100%" }}
              requiredMark={true}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item
                    {...formItemLayout}
                    label="Date of Birth(as per PAN card)"
                    name="DateOfBirth"
                    rules={[
                      {
                        required: true,
                        message: "Please select DOB",
                      },
                    ]}
                    initialValue={
                      CustDetail?.DateOfBirth
                        ? moment(CustDetail?.DateOfBirth)
                        : null
                    }
                  >
                    <DatePicker
                      suffixIcon={
                        Age ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                marginRight: "4px",
                                color: "#0000ff94",
                              }}
                            >
                              {Age} Years
                            </span>
                            <CalendarOutlined />
                          </div>
                        ) : (
                          <CalendarOutlined />
                        )
                      }
                      style={{ width: "100%", padding: "8px 10px" }}
                      disabledDate={disabledDate}
                      format="YYYY-MM-DD"
                      onChange={calculateAge}
                      defaultPickerValue={getDefaultPickerValue()}
                      placeholder="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...formItemLayout}
                    label="Gender"
                    name="gender"
                    rules={[
                      {
                        required: true,
                        message: "Please select gender",
                      },
                    ]}
                    initialValue={CustDetail?.gender}
                  >
                    <Radio.Group
                      style={{ width: "100%", gap: "10px" }}
                      className="d-flex radio-grp-custom"
                      onChange={onChange}
                    >
                      <Radio.Button value="male" className="radio-btn-cut-sec">
                        Male
                      </Radio.Button>
                      <Radio.Button
                        value="female"
                        className="radio-btn-cut-sec"
                      >
                        Female
                      </Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...formItemLayout}
                    name="is_ckyc"
                    label="Do you have CKYC Number?"
                    rules={[{ required: true, message: "Enter CKYC Number" }]}
                    initialValue={kycNumvalue}
                  >
                    <Radio.Group
                      onChange={OnckycChange}
                      style={{ width: "100%", gap: "10px" }}
                      className="d-flex radio-grp-custom"
                    >
                      <Radio.Button value="Yes" className="radio-btn-cut-sec">
                        Yes
                      </Radio.Button>
                      <Radio.Button value="No" className="radio-btn-cut-sec">
                        No
                      </Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {showCkyc === true ? (
                  <Col span={8}>
                    <Form.Item
                      {...formItemLayout}
                      initialValue={CustDetail?.ckyc_number}
                      name="ckyc_number"
                      label="CKYC Number"
                      rules={[
                        {
                          pattern: /^[0-9]+$/,
                          message: "Must be only digits",
                        },
                        { required: true, message: "Enter CKYC Number" },
                      ]}
                    >
                      <Input
                        maxLength={14}
                        placeholder="Enter CKYC Number"
                      ></Input>
                    </Form.Item>
                  </Col>
                ) : (
                  <Col span={8}>
                    <Form.Item
                      {...formItemLayout}
                      initialValue={CkycType}
                      name="ckyc_type"
                      label="CKYC Type"
                      rules={[{ required: true, message: "select CKYC type" }]}
                    >
                      <Select
                        // defaultValue={CkycType}
                        placeholder="Select Ckyc type"
                        onChange={onChangeCkycType}
                        options={[
                          {
                            value: "PAN",
                            label: "PAN NUMBER",
                          },
                          {
                            value: "AADHAAR",
                            label: "AADHAAR NUMBER",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                )}
                {showAadhaar === true && CkycType === "AADHAAR" ? (
                  <Col span={8}>
                    <Form.Item
                      {...formItemLayout}
                      initialValue={CustDetail?.aadhaar_number}
                      name="aadhaar_number"
                      label="Aadhaar Number"
                      rules={[
                        {
                          required: true,
                          message: "Enter Aadhaar Number",
                        },
                        {
                          pattern:
                            /^(?!0|1)\d{4}(?!0|1)\s?\d{4}(?!0|1)\s?\d{4}$/,
                          message: "Invalid Aadhaar Number",
                        },
                      ]}
                    >
                      <Input
                        style={{ padding: "2px 10px" }}
                        onChange={handleAadhaarNumberChange}
                        placeholder="Enter Aadhaar Number"
                      ></Input>
                    </Form.Item>
                  </Col>
                ) : null}
                {SelectedQQ?.provider === "icici" && showAadhaar === true ? (
                  <Col span={8}>
                    <Form.Item
                      {...formItemLayout}
                      label="Full Name (as per Aadhaar)"
                      name="AadhaarName"
                      rules={[
                        {
                          required: true,
                          message: "please input Name",
                        },
                      ]}
                      initialValue={CustDetail?.AadhaarName}
                    >
                      <Input
                        style={{ width: "100%" }}
                        placeholder="Full Name"
                      />
                    </Form.Item>
                  </Col>
                ) : null}
                <Col span={8}>
                  <Form.Item
                    {...formItemLayout}
                    initialValue={CustDetail?.PAN_Number}
                    name="PAN_Number"
                    label="PAN Number"
                    rules={[
                      {
                        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i,
                        message: "Invalid PAN Number",
                      },
                      { required: true, message: "Enter PAN Number" },
                    ]}
                  >
                    <Input
                      style={{ padding: "2px 10px" }}
                      onChange={handleInputChange}
                      placeholder="Enter PAN Number"
                    ></Input>
                  </Form.Item>
                </Col>
                {QuickQuotePost?.policyHolderType === "COMPANY" ? (
                  <Col span={8}>
                    <Form.Item
                      {...formItemLayout}
                      initialValue={CustDetail?.gst_number}
                      name="gst_number"
                      label="GSTIN"
                      rules={[
                        { required: true, message: "Enter GST Number" },
                        {
                          pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{4}$/,
                          message: "Invalid GST Number",
                        },
                      ]}
                    >
                      <Input
                        style={{ padding: "2px 10px" }}
                        onChange={handleGSTChange}
                        placeholder="e.g 01ABCDE1234ABCD"
                      ></Input>
                    </Form.Item>
                  </Col>
                ) : null}
              </Row>
              <Form.Item className="mb-0 text-center" {...buttonItemLayout}>
                {iciciKycSuccess ? (
                  <p className="successKyc">
                    <span style={{ marginRight: "4px" }}>
                      <CheckOutlined />
                    </span>
                    {iciciKycSuccess}
                  </p>
                ) : null}
                {iciciKycError ? (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {iciciKycError}
                  </p>
                ) : null}
                {SelectedQQ?.provider === "icici" ? (
                  showStep1 ? null : (
                    <Button
                      type="primary"
                      style={{ background: "#293890", border: "#293890" }}
                      htmlType="submit"
                      loading={loading}
                      onClick={() => handleKYCiCICI(form.getFieldsValue())}
                    >
                      Verify KYC
                    </Button>
                  )
                ) : showStep1 ? null : (
                  <Button
                    type="primary"
                    style={{ background: "#293890", border: "#293890" }}
                    htmlType="submit"
                    loading={loading}
                  >
                    Proceed To Owner Information
                  </Button>
                )}
              </Form.Item>
            </Form>
          </div>
        </div>
      )}
    </>
  );
}

export { KycVerifyNewVeh };
